/**
 * @desc 付款明细列表
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<ObjectMap>;
export function request(
  body: defs.tms.PaymentDetailRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/paymentMaster/payDetailList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
